<template>
    <div>

        <sau-template :retrieved="gotData">
            <!-- Title Placeholder -->
            <!-- <template slot="title">Services</template> -->
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Services</template>

           <!-- Data -->
            <template slot="data">
                <table v-if="Object.keys(services).length > 0" id="data-table-services" class="table table-hover data-table" data-search="Search" cellspacing="0" width="100%">
                    <thead class="d-none">
                        <tr>
                            <th>Service Type</th>
                            <th class="noshow">Type</th>
                            <th class="noshow">domain</th>
                            <th class="noshow">SAU Order Id</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="service in services" :key="service.id">
                            <td>
                                <a :href="`/service/${service.type}/${service.id}`">
                                    <div class="d-flex product-list">
                                        <div>
                                            <!-- Icons mapped in SauFunctions -->
                                            <template v-if="service.type === 'virtual-data-centre'">
                                                <i class="fal fa-chart-network primary pr-8 pt-2 pl-2" style="font-size: 3rem;"></i>
                                            </template>
                                            <template v-else-if="service.type === 'nimble'">
                                                <i class="fal fa-warehouse-alt primary pr-8 pt-2 pl-2" style="font-size: 3rem;"></i>
                                            </template>
                                            <template v-else>
                                                <i class="product-icons pr-6 pt-2" :class="icons[service.type]" aria-hidden="true"></i>
                                            </template>
                                        </div>
                                        <div>
                                            <p class="product-name">
                                                <template v-if="service.group">{{ service.group }} - </template>
                                                <template v-if="service.name">{{ service.name }}</template>
                                            </p>
                                            <!-- Hidden field for searchable tags -->
                                            <p class="d-none">{{service.tags}}</p>
                                            <p class="product-desc" v-if="service.domain">{{ service.domain }}</p>
                                            <p class="product-desc" v-if="service.sau_order_id"><span class="sau-font-bold">SAU Order ID:</span> {{ service.sau_order_id }}</p>
                                            <p class="product-desc"><span class="sau-font-bold">Service Status: </span> - <span :class="statusClass(service.status)">{{ service.status }}</span></p>
                                            <input  type="text" :id="generateId(service.id)"  class="load-user-tags" :data-tags="service.tags" style="width:100%;"/>
                                        </div>
                                    </div>
                                </a>
                            </td>
                            <td :data-filter="applyFilter('type', service.type)">{{ service.type }}</td>
                            <td :data-filter="applyFilter('domain', service.domain)">{{ service.domain }}</td>
                            <td :data-filter="applyFilter('sau-order-id', service.sau_order_id)">{{ service.sau_order_id }}</td>
                        </tr>
                    </tbody>
                </table>

                <div v-else-if="notAuthorised">
                    <sau-request-permission></sau-request-permission>
                </div>

                 <div v-else class="sau-bx text-center">
                    <div class="row p-2">
                        <div class="col">
                            <img src="/img/apiro-star.gif" class="mx-auto">
                            <h4>You don't have any Services at the moment</h4>
                            <p>Get started now by ordering a Service with Servers Australia. All backed by our 24/7 Australian-based support.</p>
                        </div>
                    </div>

                    <div class="row px-12 pb-6">
                        <div class="col-sm-12 col-xl-4 bdr-rt bdr-1" v-for="product in productDisplay" :key="product.id">
                            <div class="d-flex flex-column align-items-center p-4 h-100">
                                <h3 class="sau-pm-reset">{{product.title}}</h3>
                                <div class="mb-auto clearfix">
                                    <div class="text-center">
                                        <hr />
                                        <p class="sau-font xs sau-para-m">From</p>
                                        <h2>$ {{product.price}}</h2>
                                        <p class="sau-font xs sau-minus-m">Per Month</p>
                                        <hr />
                                        <div class="d-flex align-items-stretch">
                                            <p class="sau-font sm text-center">{{product.desc}}</p>
                                        </div>
                                    </div>
                                </div>
                                <a :href="product.link" target="_blank" class="sau-link-button sm px-12 mb-6">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </sau-template>

    </div>
</template>
<script>
    import jsFunctions from '@js/store/jqueryFunctions';
    export default {
        mixins: [jsFunctions],
        data() {
            return {
                services: '',
                notAuthorised: false,
            };
        },
        created() {
            this.startApp();
        },
        computed:{
            productDisplay(){
                return _.sampleSize(Object(this.products),3)
            }
        },
        methods: {
            startApp() {
                this.getServices().then(response => {
                    this.services = response.data;
                    if(this.services) {
                        this.$nextTick(() => {
                            this.initializeDataTables();
                            this.initializeUserTags();
                        })
                    }
                }).catch(error => {
                    this.notAuthorised = true;
                })
            },
            generateId(id) {
                return `service-${id}`;
            },
            statusClass(status) {
                switch(status.toLowerCase()) {
                    case 'active':
                        return 'text-success';
                            break;
                    case 'suspended':
                        return 'text-warning';
                            break;
                    case 'pending':
                    default:
                        return 'text-info';
                            break;
                }
            }
        },
    }
</script>
<style>
    #data-table-services a {
        color:#666;
        text-decoration: none;
    }
    input {
        z-index:10;
    }
</style>
